import React from "react";

import Divider from "./Divider";

//Title banner at the top of About / Products / Contact, ending in that page's divider shape
const PageBanner = ({ title, subtitle, color, divider, dividerColor }) => (
  <section
    className={"page-banner"}
    style={{ "--banner-color": color, "--divider": dividerColor }}
  >
    <div className={"page-banner-text"}>
      <h1 className={"page-banner-title"}>{title}</h1>
      <p className={"page-banner-subtitle"}>{subtitle}</p>
    </div>
    <Divider shape={divider} />
  </section>
);

export default PageBanner;
